<div *ngIf="documentoDadosMovimento != undefined">
  <p-dialog
    header="Visualizar dados do Documento"
    [(visible)]="visivel"
    [modal]="true"
    [style]="{ width: '60vw'}"
    [draggable]="false"
    [resizable]="false">
    <p-tabView [(activeIndex)]="tabViewDocumentosIndex">
      <p-tabPanel header="Dados">
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Id:</div>
          <div class="p-col-8">{{documentoDadosMovimento.id}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Nome:</div>
          <div class="p-col-8">{{documentoDadosMovimento.nome}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Origem Id:</div>
          <div class="p-col-8">{{documentoDadosMovimento.origemId}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Data de juntada:</div>
          <div class="p-col-8">{{documentoDadosMovimento.dataJuntada | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid" *ngIf="documentoDadosMovimento.excluido">
          <div class="p-col-4">Data da exclusão: </div>
          <div class="p-col-8">{{documentoDadosMovimento.dataExclusao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
        </div>
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Tipo:</div>
          <div class="p-col-8">
            <a href="tipoProcessoDocumento/visualizar/{{documentoDadosMovimento?.tipo?.id}}">
              {{documentoDadosMovimento?.tipo?.id}} - {{documentoDadosMovimento?.tipo?.nome}}
            </a>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-4 p-text-bold">Tipo de arquivo: </div>
          <div class="p-col-8">{{documentoDadosMovimento.categoriaArquivo}} - {{documentoDadosMovimento.tipoArquivo}}
          </div>
        </div>
        <div class="p-grid" *ngIf="documentoDadosMovimento?.signatarios?.length > 0">
          <div class="p-col-4 p-text-bold">Signatários: </div>
          <div class="p-col-8">
            <li *ngFor="let signatario of documentoDadosMovimento.signatarios">
              <a href="/pessoa/visualizar/{{signatario.signatario.id}}">{{signatario.signatario.nome}}</a>
            </li>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Arquivo" [disabled]="!documentoDadosMovimento.processado">
        <div *ngIf="documentoDadosMovimento.processado">
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Id: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.id}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Tipo: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.categoria}} - {{documentoDadosMovimento.arquivo.tipo}}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Hash: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.hash}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Tamanho do arquivo original: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.tamanho / 1024}}kb</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Tamanho do arquivo texto: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.tamanhoTexto}}bytes</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4">Transformações: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.transformacoes}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Data do processamento: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.dataProcessamento | date: 'dd/MM/yyyy HH:mm:ss'}}
            </div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Tempo do processamento: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.tempoProcessamento}}ms</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Tempo de conversão: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.tempoConversao}}ms</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Versão do prisma: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.versaoPrisma}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Quantidade de páginas: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.quantidadePaginas}}</div>
          </div>
          <div class="p-grid">
            <div class="p-col-4 p-text-bold">Quantidade de imagens: </div>
            <div class="p-col-8">{{documentoDadosMovimento.arquivo.quantidadeImagens}}</div>
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Texto" [disabled]="documentoDadosMovimento.arquivo === undefined">
        <div style="border: 1px solid #d3d3d3; height: 595px; padding: 1em; overflow-y: scroll;">
          <div [innerText]="processoDocumentoTexto" *ngIf="documentoDadosMovimento.processado"></div>
          <div *ngIf="!documentoDadosMovimento.processado">
            <span class="fa pi-exclamation-triangle pendente"></span> O texto do documento ainda não foi
            extraído.
          </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Original">
        <app-arquivo-visualizador [arquivo]="processoDocumentoArquivo"></app-arquivo-visualizador>
      </p-tabPanel>
    </p-tabView>
    <ng-template pTemplate="footer">
      <p-button (click)="fecharModal()" label="Fechar"></p-button>
    </ng-template>
  </p-dialog>
</div>





